"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAlias;

var _reactGlobalConfiguration = _interopRequireDefault(require("react-global-configuration"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getShootstaSegments() {
  try {
    return _reactGlobalConfiguration["default"].get('shootstaDomainSegments');
  } catch (error) {
    return null;
  }
}

var SHOOTSTA_ALIAS = 'shootsta';

function getAlias() {
  var reservedSegments = getShootstaSegments();
  var reservedSegmentsArray = reservedSegments ? reservedSegments.split(',') : [];
  var subdomainSegments = window.location.hostname.split('.');
  return reservedSegmentsArray.includes(subdomainSegments[0]) ? SHOOTSTA_ALIAS : subdomainSegments[0];
}